import React from "react";

import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';

import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { DBInstanceCloneField, DBInstancesListField, InstanceActivityLogsListField, InstanceAutoBackupsField, InstanceAutoBackupsListField, InstanceManagementField, InstanceManagementListField, InstanceStoredProceduresListField } from '../../Utilities/Enums/ParametersEnum';
import { ActiveStatusEnum, DBBackupStatusEnum, DBInstancesStatusEnum, InstanceAutoBackupStatusEnum, InstanceAutoBackupTypeEnum, InstanceBackupConfigFrequencyEnum, InstanceDataModeEnum, InstanceStatusEnum, InstanceStoredProcedureStatusEnum, SchemaHealthStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { CurrencyEnum } from '../../Utilities/Enums/CurrencyEnums';

export class InstanceMngt {
    [InstanceManagementField.PUBLIC_ID]?: string | number = "";
    [InstanceManagementField.NAME]?: string = "";
    [InstanceManagementField.DATABASE]?: string = "";
    [InstanceManagementField.IS_ON_PREMISE]?: boolean = false;
    [InstanceManagementField.ENGINE]?: string = "";
    [InstanceManagementField.COMPANY_NAME]?: string = "";
    [InstanceManagementField.STATUS]: InstanceStatusEnum = InstanceStatusEnum.ALL;
    [InstanceManagementField.DB_VERSION]?: string = "";
    [InstanceManagementField.BUILD_VERSION]?: string = "";
    [InstanceManagementField.SCHEMA_REVISON]?: string = "";
    [InstanceManagementField.LAST_MIGRATION_NAME]?: string = "";
    [InstanceManagementField.LAST_MIGRATION_DATE]?: string | Date | null = null;
    [InstanceManagementField.PENDING_MIGRATIONS]?: number = 0;
    [InstanceManagementField.SCHEMA_HEALTH]?: SchemaHealthStatusEnum | number = SchemaHealthStatusEnum.HEALTHY;
    [InstanceManagementField.TABLES_PRESENT]?: number = 0;
    [InstanceManagementField.TABLES_TOTAL]?: number = 0;
    [InstanceManagementField.INDEXES_VALID]?: number = 0;
    [InstanceManagementField.INDEXES_TOTAL]?: number = 0;
    [InstanceManagementField.STORED_PROC_VALID]?: number = 0;
    [InstanceManagementField.STORED_PROC_TOTAL]?: number = 0;
    [InstanceManagementField.FUNCTIONS_VALID]?: number = 0;
    [InstanceManagementField.FUNCTIONS_TOTAL]?: number = 0;
    [InstanceManagementField.COLLATION]?: string = "";
    [InstanceManagementField.COLLATION_MATCHES_BASELINE]?: boolean = false;
    [InstanceManagementField.VERSION_MATCHES_BASELINE]?: boolean = false;
    [InstanceManagementField.DATABASE_SIZE_GB]?: number = 0;
    [InstanceManagementField.STORAGE_CAPACITY_GB]?: number = 0;
    [InstanceManagementField.ACTIVE_CONNECTIONS]?: number = 0;
    [InstanceManagementField.MAX_CONNECTIONS]?: number = 0;
    [InstanceManagementField.LATENCY_MS]?: number = 0;
    [InstanceManagementField.BACKUP_STATUS]?: DBBackupStatusEnum = DBBackupStatusEnum.ENABLED;
    [InstanceManagementField.LAST_BACKUP_DATE]?: string | Date | null = null;
    [InstanceManagementField.LAST_CHECKED_AT]?: string | Date | null = null;
    [InstanceManagementField.PROBE_ERROR]?: string = "";

    [InstanceManagementField.FOREIGN_KEYS_CONSTRAINTS]?: number = 0;
    [InstanceManagementField.VALID_CONSTRAINTS]?: number = 0;
    [InstanceManagementField.ORPHANED_RECORDS_COUNT]?: number = 0;

    [InstanceManagementField.FOREIGN_KEYS_TOTAL]?: number = 0;
    [InstanceManagementField.FOREIGN_KEYS_ENABLED]?: number = 0;
    [InstanceManagementField.CHECK_CONSTRAINTS_TOTAL]?: number = 0;
    [InstanceManagementField.CHECK_CONSTRAINTS_VALID]?: number = 0;
    [InstanceManagementField.ORPHANED_RECORDS_DETAIL]?: string = "";
    [InstanceManagementField.SCHEMA_CHECKED_AT]?: string | Date | null = null;

    [InstanceManagementField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceManagementField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceMngt>) {
        Object.assign(this, obj);
    }
}

export class InstanceMngtList {
    [InstanceManagementListField.PUBLIC_ID]?: string | number = "";
    [InstanceManagementListField.DATABASE]?: string = "";
    [InstanceManagementListField.COMPANY_NAME]?: string = "";
    [InstanceManagementListField.STATUS]: InstanceStatusEnum = InstanceStatusEnum.ALL;
    [InstanceManagementListField.DB_VERSION]?: string = "";
    [InstanceManagementListField.SCHEMA_HEALTH]?: SchemaHealthStatusEnum | number = SchemaHealthStatusEnum.HEALTHY;
    [InstanceManagementListField.SP_INTEGRITY]?: string = "";
    [InstanceManagementListField.LAST_BACKUP_DATE]?: string | Date | null = null;
    [InstanceManagementListField.LAST_CHECKED_AT]?: string | Date | null = null;

    [InstanceManagementListField.BUILD_VERSION]?: string = "";
    [InstanceManagementListField.BACKUP_STATUS]?: DBBackupStatusEnum = DBBackupStatusEnum.ENABLED;
    [InstanceManagementListField.ENGINE]?: string = "";
    [InstanceManagementListField.IS_ON_PREMISE]?: boolean = false;
    [InstanceManagementListField.NAME]?: string = "";
    [InstanceManagementListField.PENDING_MIGRATIONS]?: number = 0;
    [InstanceManagementListField.STORED_PROC_TOTAL]?: number = 0;
    [InstanceManagementListField.STORED_PROC_VALID]?: number = 0;


    [InstanceManagementListField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceManagementListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceMngtList>) {
        Object.assign(this, obj);
    }
}

export class InstanceStoredProceduresList {
    [InstanceStoredProceduresListField.ROW_ID]?: number = 0;
    [InstanceStoredProceduresListField.LAST_COMPILED]?: string | Date | null = null;
    [InstanceStoredProceduresListField.NAME]?: string = "";
    [InstanceStoredProceduresListField.SCHEMA]?: string = "";
    [InstanceStoredProceduresListField.STATUS]?: InstanceStoredProcedureStatusEnum = InstanceStoredProcedureStatusEnum.VALID;
    [InstanceStoredProceduresListField.ERROR_TEXT]?: string = "";

    [InstanceStoredProceduresListField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceStoredProceduresListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceStoredProceduresList>) {
        Object.assign(this, obj);
    }
}

export class InstanceAutoBackupsList {
    [InstanceAutoBackupsListField.PUBLIC_ID]?: string | number = "";
    [InstanceAutoBackupsListField.BACKUP_DATE]?: string | Date | null = null;
    [InstanceAutoBackupsListField.TYPE]?: InstanceAutoBackupTypeEnum = InstanceAutoBackupTypeEnum.AUTOMATIC;
    [InstanceAutoBackupsListField.SIZE_GB]?: number = 0;
    [InstanceAutoBackupsListField.DURATION_SECONDS]?: number = 0;
    [InstanceAutoBackupsListField.STATUS]?: InstanceAutoBackupStatusEnum = InstanceAutoBackupStatusEnum.SUCCESS;

    [InstanceAutoBackupsListField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceAutoBackupsListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceAutoBackupsList>) {
        Object.assign(this, obj);
    }
}

export class InstanceAutoBackupConfig {
    [InstanceAutoBackupsField.COMPANY_PUBLIC_ID]?: string | number = "";
    [InstanceAutoBackupsField.ENABLED]?: boolean = false;
    [InstanceAutoBackupsField.FREQUENCY]?: InstanceBackupConfigFrequencyEnum = InstanceBackupConfigFrequencyEnum.DAILY;
    [InstanceAutoBackupsField.PREFERRED_TIME]?: string | Date | null = null;
    [InstanceAutoBackupsField.RETENTION_DAYS]?: number = 0;
    [InstanceAutoBackupsField.DESTINATION]?: string = 'Local disk (on-premise)';
    [InstanceAutoBackupsField.ENCRYPT_AT_REST]?: boolean = false;
    [InstanceAutoBackupsField.POINT_IN_TIME_RESTORE]?: boolean = false;

    [InstanceAutoBackupsField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceAutoBackupsField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceAutoBackupConfig>) {
        Object.assign(this, obj);
    }
}

export class DBInstancesList {
    [DBInstancesListField.PUBLIC_ID]?: string | number = "";
    [DBInstancesListField.INSTANCE_NAME]?: string = "";
    [DBInstancesListField.SOURCE_NAME]?: string = "";
    [DBInstancesListField.DATA_MODE]?: InstanceDataModeEnum = InstanceDataModeEnum.FULL_COPY;
    [DBInstancesListField.STATUS]?: DBInstancesStatusEnum = DBInstancesStatusEnum.READY;
    [DBInstancesListField.SIZE_GB]?: number = 0;
    [DBInstancesListField.AUTO_DELETE_AT]?: string | Date | null = null;
    [DBInstancesListField.NOTIFY_WHEN_READY]?: boolean = false;
    
    [DBInstancesListField.CREATED_BY_NAME]?: string = "";
    [DBInstancesListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<DBInstancesList>) {
        Object.assign(this, obj);
    }
}

export class DBInstanceClone {
    [DBInstanceCloneField.PUBLIC_ID]?: string | number = "";
    [DBInstanceCloneField.INSTANCE_NAME]?: string = '';
    [DBInstanceCloneField.DATA_MODE]?: InstanceDataModeEnum = InstanceDataModeEnum.FULL_COPY;
    [DBInstanceCloneField.AUTO_DELETE_AFTER_DAYS]?: number = 0;
    [DBInstanceCloneField.NOTIFY_WHEN_READY]?: boolean = false;

    [DBInstanceCloneField.UPDATED_DATE]?: string | Date | null = null;
    [DBInstanceCloneField.CREATED_DATE]?: string | Date | null = null;
    [DBInstanceCloneField.CREATED_BY_NAME]?: string = '';

    constructor(obj?: Partial<DBInstanceClone>) {
        Object.assign(this, obj);
    }
}

export class InstanceActivityLogsList {
    [InstanceActivityLogsListField.PUBLIC_ID]?: string | number = "";
    [InstanceActivityLogsListField.ACTIVITY_DATE]?: string | Date | null = null;
    [InstanceActivityLogsListField.ACTOR]?: string = "";
    [InstanceActivityLogsListField.MESSAGE]?: string = "";

    [InstanceActivityLogsListField.UPDATED_DATE]?: string | Date | null = null;
    [InstanceActivityLogsListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<InstanceActivityLogsList>) {
        Object.assign(this, obj);
    }
}

export class MaintenanceModeConfirmationDialogModel {
    openDialog?: boolean = false;
    handleClose: () => void = () =>{};
    // buttonAction: (remarks: any) => void = (remarks: any) =>{};
    buttonAction: () => void = () =>{};
    instanceName?: string | number | null = 'this instance';

    constructor(obj?: Partial<MaintenanceModeConfirmationDialogModel>) {
        Object.assign(this, obj);
    }
}

export class InstanceAutoBackUpInterface {
    instanceName?: string;
    autoBackupConfig?: InstanceAutoBackupConfig;
    previewAutoBackupConfig?: InstanceAutoBackupConfig
    setautoBackupConfig?: React.Dispatch<React.SetStateAction<InstanceAutoBackupConfig>>;
    setpreviewAutoBackupConfig?: React.Dispatch<React.SetStateAction<InstanceAutoBackupConfig>>;
    triggeredQuery?: any
    settriggeredQuery?: React.Dispatch<React.SetStateAction<any>>;
}

export class DBInstanceInterface {
    instanceName?: string;
    triggeredQuery?: any
    settriggeredQuery?: React.Dispatch<React.SetStateAction<any>>;
}

export class BackupConfigModalInterface {
    instanceName?: string;
    autoBackupConfig?: InstanceAutoBackupConfig;
    previewAutoBackupConfig?: InstanceAutoBackupConfig
    setautoBackupConfig?: React.Dispatch<React.SetStateAction<InstanceAutoBackupConfig>>;
    setpreviewAutoBackupConfig?: React.Dispatch<React.SetStateAction<InstanceAutoBackupConfig>>;

    openBackupConfigModal?: boolean;
    setopenBackupConfigModal?: React.Dispatch<React.SetStateAction<boolean>>;
    handleSubmitBackupConfig?: () => void = () =>{};
    DropdownData?: any;
    dropdownFetchStatus?: any;
}

export class BackupRestoreConfirmationDialogModel {
    selectedRecord?: InstanceAutoBackupsList;
    openDialog?: boolean = false;
    handleClose: () => void = () =>{};
    // buttonAction: (remarks: any) => void = (remarks: any) =>{};
    buttonAction: () => void = () =>{};
    instanceName?: string | number | null = 'this instance';

    constructor(obj?: Partial<BackupRestoreConfirmationDialogModel>) {
        Object.assign(this, obj);
    }
}

export class DBCloneModalInterface {
    instanceName?: string;

    openDBCloneModal?: boolean;
    setopenDBCloneModal?: React.Dispatch<React.SetStateAction<boolean>>;
    handleCloneDB?: (cloneForm: DBInstanceClone) => void = (cloneForm: DBInstanceClone) =>{};
    DropdownData?: any;
    dropdownFetchStatus?: any;
}

export class InstanceStoredProcedureInterface {
    triggeredQuery?: any
    settriggeredQuery?: React.Dispatch<React.SetStateAction<any>>;
}

export class InstanceActivityLogInterface {
    triggeredQuery?: any
    settriggeredQuery?: React.Dispatch<React.SetStateAction<any>>;
}